var StreamVideoGroup = require("./video-group.js");

$(".stream-video-group").each(function () {
    new StreamVideoGroup($(this));
});
